import { render } from "./DashboardCompetitiveRank.vue?vue&type=template&id=c299bd50"
import script from "./DashboardCompetitiveRank.vue?vue&type=script&lang=js"
export * from "./DashboardCompetitiveRank.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__